import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "sign-in-wrapper",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onClickRight && $options.onClickRight.apply($options, arguments);
    })
  }, " 签到 ");
}